import { green, grey } from "@mui/material/colors";
import { ListItem } from "../types";
export const ASSET_STATUS_LIST: ListItem[] = [
  {
    value: "functional",
    label: "functional",
  },
  {
    value: "non-functional",
    label: "non-functional",
  },
];

export const ASSET_BRAND_NAME: ListItem[] = [
  { value: "Acer", label: "Acer" },
  { value: "APC", label: "APC" },
  { value: "Apple", label: "Apple" },
  { value: "Asus", label: "Asus" },
  { value: "BenQ", label: "BenQ" },
  { value: "Brother", label: "Brother" },
  { value: "Canon", label: "Canon" },
  { value: "Cisco", label: "Cisco" },
  { value: "CyberPower", label: "CyberPower" },
  { value: "D-Link", label: "D-Link" },
  { value: "Dell", label: "Dell" },
  { value: "Eaton", label: "Eaton" },
  { value: "Epson", label: "Epson" },
  { value: "Google", label: "Google" },
  { value: "HP", label: "HP" },
  { value: "Huawei", label: "Huawei" },
  { value: "Infinix", label: "Infinix" },
  { value: "Konica-Minolta", label: "Konica Minolta" },
  { value: "Kyocera", label: "Kyocera" },
  { value: "Lenovo", label: "Lenovo" },
  { value: "LG", label: "LG" },
  { value: "Mercury", label: "Mercury" },
  { value: "MikroTik", label: "MikroTik" },
  { value: "Microsoft", label: "Microsoft" },
  { value: "MSI", label: "MSI" },
  { value: "Netgear", label: "Netgear" },
  { value: "Nokia", label: "Nokia" },
  { value: "OnePlus", label: "OnePlus" },
  { value: "Optoma", label: "Optoma" },
  { value: "Ricoh", label: "Ricoh" },
  { value: "Samsung", label: "Samsung" },
  { value: "Sharp", label: "Sharp" },
  { value: "Sony", label: "Sony" },
  { value: "TP-Link", label: "TP-Link" },
  { value: "Tecno", label: "Tecno" },
  { value: "Toshiba", label: "Toshiba" },
  { value: "Ubiquiti", label: "Ubiquiti" },
  { value: "Vertiv", label: "Vertiv" },
  { value: "ViewSonic", label: "ViewSonic" },
  { value: "Xerox", label: "Xerox" },
  { value: "Xiaomi", label: "Xiaomi" },
];

export const ASSET_ISSUE_LIST: ListItem[] = [
  {
    value: "breakdown",
    label: "breakdown",
  },
  {
    value: "fire outbreak",
    label: "fire outbreak",
  },
  {
    value: "flood",
    label: "flood",
  },
  {
    value: "missing",
    label: "missing",
  },
  {
    value: "spoilt",
    label: "spoilt",
  },
  {
    value: "other",
    label: "other",
  },
];

export const ASSET_SCHEDULE_STATUS: ListItem[] = [
  {
    value: "scheduled",
    label: "scheduled",
  },
  {
    value: "in-progress",
    label: "in-progress",
  },
  {
    value: "on-hold",
    label: "on-hold",
  },
  {
    value: "completed",
    label: "completed",
  },
  {
    value: "cancelled",
    label: "cancelled",
  },
];

export const ASSET_OWNERSHIP_LIST: ListItem[] = [
  {
    value: "official",
    label: "official",
  },
  {
    value: "personal",
    label: "personal",
  },
];

export const COURIER_TRANSPORT_MODES: ListItem[] = [
  {
    value: "Land",
    label: "Land",
  },
  {
    value: "Air",
    label: "Air",
  },
  {
    value: "Sea",
    label: "Sea",
  },
];

export const VEHICLE_TYPES: ListItem[] = [
  {
    value: "Truck",
    label: "Truck",
  },
  {
    value: "Bus",
    label: "Bus",
  },
  {
    value: "Car",
    label: "Car",
  },
  {
    value: "Ship",
    label: "Ship",
  },
  {
    value: "Plane",
    label: "Plane",
  },
  {
    value: "Train",
    label: "Train",
  },
];

export const CHART_COLORS = [
  green[900],
  green[700],
  green[500],
  green[400],
  green["A100"],
  green[300],
  green[100],
  grey[900],
  grey[700],
  grey[500],
  grey[400],
  grey[300],
];

export const DistributionBatchStatus = {
  pending: "pending",
  in_transit: "in-transit",
  received: "received",
} as const;

export type DistributionBatchType =
  (typeof DistributionBatchStatus)[keyof typeof DistributionBatchStatus];
export const distributionBatchStatusList = Object.values(
  DistributionBatchStatus
).map((item) => item);

export const AssetDistributionStatus = {
  pending: "pending",
  in_transit: "in-transit",
  received: "received",
  rejected: "rejected",
} as const;

export type AssetDistributionStatusType =
  (typeof AssetDistributionStatus)[keyof typeof AssetDistributionStatus];
export const assetDistributionStatusList = Object.values(
  AssetDistributionStatus
).map((item) => item);

export const AssetAssignmentStatus = {
  pending: "pending",
  assigned: "assigned",
  not_assigned: "not-assigned",
  rejected: "rejected",
} as const;

export type AssetAssignmentStatusType =
  (typeof AssetAssignmentStatus)[keyof typeof AssetAssignmentStatus];
export const assetAssignmentStatusList = Object.values(
  AssetAssignmentStatus
).map((item) => item);
